import React from 'react';
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';



export const addNewExpert = (expertInfo,experts,selectedEx,setExpertInfo) => {
    // console.log(experts)
    // console.log(expertInfo)
    let arry = selectedEx;
    let ex = experts.find((e) =>{
        return e.value === expertInfo.ExExpertId
    })
    let newEx = {
        img : ex.img,
        name : ex.label,
        type : expertInfo.type,
        time: expertInfo.time,
        date : expertInfo.date,
        scheduleId : expertInfo.scheduleId
    }
    let addEx = {
        ExExpertId: expertInfo.ExExpertId,
        scheduleId: expertInfo.scheduleId,
        time: expertInfo.time,
        date: expertInfo.date
    }

    if( expertInfo.number=== "single" || expertInfo.number !== "several" ){
        arry = [newEx]
        let x = [addEx]
        let copy = expertInfo
        copy.arry = x
        setExpertInfo(copy)
        // console.log("c",copy)
    }else if( expertInfo.number === "several"){
        arry.push(newEx)
        let x = expertInfo.arry || []
        x.push(addEx)
        let copy = expertInfo
        copy.arry = x
        setExpertInfo(copy)
        console.log("c",copy)
    }
    return arry
}

const ExpertTabel = () => {
    const {selectedEx,setSelectedExpert} = useContext(userContext)

    const deleteExpert = (id)=>{
        // console.log(id)
         const updatedExpert = selectedEx.filter((c) => c.scheduleId !== id);
         setSelectedExpert(updatedExpert);
    }


    return (
        <div className='table-box table-responsive'>
        <table className="table table-bordered text-center">
        <thead>
          <tr style={{color:"#fff"}}>
            <th scope="col" >ردیف</th>
            <th scope="col" style={{maxWidth:"140px"}}>تصویر کارشناسی</th>
            <th scope="col">نام کارشناسی</th>
            <th scope="col">نوع کارشناس</th>
            <th scope="col">زمان</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
         {
            selectedEx.map((i,index) => (
                <tr key={index} style={{color:"#fff"}}>
                <th >{index+1}</th>
                <td><img alt='img' src={i.img} width={40} height={40}/></td>
                <td>{i.name}</td>
                <td>{i.type === "Local" ? "محلی" : "رسمی"}</td>
                <td>
                <p className='mb-0'>{i.date}</p>
                <p className='mb-0'>{i.time}</p>
                </td>
                <td><button className='btn btn-danger' onClick={()=>{deleteExpert(i.scheduleId)}}>حذف </button></td>
              </tr>
            ))
         }
        </tbody>
      </table>
        </div>
    );
};

export default ExpertTabel;